<template>
  <li><a class="logout" @click="logout" title="Odhlášení">Odhlášení</a></li>
</template>

<script>
export default {
  name: 'logout-button',
  methods: {
    logout() {
      this.$auth.logout({
        redirect: '/'
      })
    }
  }
}
</script>
